import { VALID_SHIFTS } from '@/utils/constants';

export const isAValidShift = (
  value: string | null,
  message: string = 'Required',
): boolean | string => {
  if (value === null) {
    return true;
  }

  const parsedValue = parseInt(value);
  if (parsedValue !== 0 && !parsedValue) {
    return message;
  }

  return VALID_SHIFTS.includes(parsedValue) ? true : message;
};
